import parkingMachine from "../assets/images/parking-machine.svg";
import infoBoxIcon from "../assets/images/info-solid.svg";
import parkingIcon from "../assets/images/parking.svg";
import { ITicket } from "types/ticket.type";
import { ParkingType } from "types/parkingType.type";

export const getParkingType = (ticket: ITicket): ParkingType => {
    if (ticket.parkMachineCode)  return ParkingType.ParkingMachine;
    if (ticket.sectionCode) return ParkingType.ParkingZone;
        
	// Fallback
    return ParkingType.ParkingZone;
};

export const getParkingTypeIcon = (type: ParkingType) => {
	switch (type) {
		case ParkingType.ParkingZone:
			return parkingIcon;
		case ParkingType.ParkingMachine:
			return parkingMachine;
		case ParkingType.InfoBox:
			return infoBoxIcon;
	}
};